module.exports = __webpack_public_path__ + "static/img/eight-hours.1bbb8c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/career_planning/eight-hours.png
// module id = jtwY
// module chunks = 1